const en_US = {
  profile: 'Profile',
  logout: 'Logout',
  docs: 'Docs',
};
export default en_US;
